/* ====================================================
   BRIXKOM Brand-Layer JS
   - Mobile-Nav-Toggle (.bx-header__toggle → .bx-header__nav.is-open)
   ==================================================== */

(function () {
  const toggle = document.querySelector('.bx-header__toggle');
  const nav = document.querySelector('.bx-header__nav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
  });
})();
